import { render, staticRenderFns } from "./contentCard.vue?vue&type=template&id=1f1d70ef&scoped=true"
import script from "./contentCard.vue?vue&type=script&lang=js"
export * from "./contentCard.vue?vue&type=script&lang=js"
import style0 from "./contentCard.vue?vue&type=style&index=0&id=1f1d70ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d70ef",
  null
  
)

export default component.exports